<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <div>
        <h2>佣金应收</h2>
        <p>应收来自已确认或历史成交核算，收款不会重新计算员工佣金</p>
      </div>
      <el-button
        :loading="loading"
        @click="load"
      >
        刷新
      </el-button>
    </div>
    <el-card shadow="never">
      <div class="filters">
        <el-input
          v-model="keyword"
          clearable
          placeholder="客户、房源编号或分部"
          @keyup.enter="reload"
        />
        <el-button
          type="primary"
          @click="reload"
        >
          查询
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="rows"
        stripe
      >
        <el-table-column
          prop="transaction_id"
          label="成交编号"
          width="100"
        />
        <el-table-column
          prop="customer_name"
          label="客户"
          min-width="130"
        />
        <el-table-column
          prop="housing_number"
          label="房源编号"
          min-width="130"
        />
        <el-table-column
          prop="tran_point"
          label="成交分部"
          width="130"
        />
        <el-table-column
          label="应收佣金"
          width="140"
        >
          <template #default="{ row }">
            ¥ {{ money(row.receivable_amount) }}
          </template>
        </el-table-column>
        <el-table-column
          label="已收金额"
          width="140"
        >
          <template #default="{ row }">
            ¥ {{ money(row.received_amount) }}
          </template>
        </el-table-column>
        <el-table-column
          label="未收金额"
          width="140"
        >
          <template #default="{ row }">
            <b class="danger">¥ {{ money(row.outstanding_amount) }}</b>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="100"
        >
          <template #default="{ row }">
            <el-tag
              :type="Number(row.outstanding_amount) > 0 ? 'warning' : 'success'"
            >
              {{ Number(row.outstanding_amount) > 0 ? '待收款' : '已收清' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-empty
        v-if="!loading && !rows.length"
        description="暂无应收记录"
      />
      <div class="pager">
        <el-pagination
          v-model:current-page="page"
          v-model:page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
          @current-change="load"
          @size-change="reload"
        />
      </div>
    </el-card>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { ledgerApi } from '../api'

const rows = ref([])
const loading = ref(false)
const keyword = ref('')
const page = ref(1)
const pageSize = ref(20)
const total = ref(0)
const money = (value) =>
  Number(value || 0).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
const load = async () => {
  loading.value = true
  try {
    const data = await ledgerApi.receivables({
      page: page.value,
      pageSize: pageSize.value,
      keyword: keyword.value,
    })
    rows.value = data.items || []
    total.value = data.total || 0
  } catch (error) {
    ElMessage.error(error?.message || '应收加载失败')
  } finally {
    loading.value = false
  }
}
const reload = () => {
  page.value = 1
  load()
}
onMounted(load)
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8a97a8;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
.filters {
  display: flex;
  gap: 10px;
  width: 480px;
  margin-bottom: 16px;
}
.pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}
.danger {
  color: #c22525;
}
</style>
